import { render } from "./FormNotice.vue?vue&type=template&id=3dcf1f9c&scoped=true"
import script from "./FormNotice.vue?vue&type=script&lang=js"
export * from "./FormNotice.vue?vue&type=script&lang=js"

import "./FormNotice.vue?vue&type=style&index=0&id=3dcf1f9c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3dcf1f9c"

export default script